import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Label, Pagination } from 'ypf-pas-general-ui-components';

import InputCalendar from '../../../Calendar/InputCalendar/InputCalendar';
import NoWorkReports from '../../../WorkReports/NoWorkReports';
import { formatFullDate, formatsEnum } from '../../../../utils/formatUtils';
import { workReportsProp } from '../../../../utils/globalPropTypes';
import { AttachedFilesPermissions } from '../../../MonthlyServiceRequest/RequestDetailTypes';
import DailyTotal from '../DailyTotal/DailyTotal';
import ApprovalButton from '../ButtonsApprovalPending/ApprovalButton';
import HeaderLocation from '../HeaderLocation/HeaderLocation';
import HeaderTableApprovalPending from '../TableApproval/HeaderTableApprovalPending';
import ApprovalHeaderButtons from '../../ApprovalHeaderButtons/ApprovalHeaderButtons';
import './ApprovalPending.scss';
import ModalSummaryApprovalPending from '../ModalSummaryApprovalPending/ModalSummaryApprovalPending';
import { postSummaryPendingAdapter } from '../../../../adapters/weekly-report/get-weekly-report-adapter';
import { bulidFilterWorkReportRequestNoPage } from '../../../../page/ServiceRequest/FilterServiceRequest/utils/filterServiceRequestUtils';
import { useFilterContext } from '../../../../context/FilterContext';

const ApprovalPending = ({
  calendarioRevision,
  fetchData,
  pageIndex,
  partesDiarios,
  partesTotales,
  selectedDate,
  setDateWorkReport,
  setIsPending,
  setPageIndex,
  size,
  totalPages,
  totalRecords,
  workReports,
  handleGoFirstLastDay,
  handleOrderByUbication,
  isOrderByUbication,
  handlePageSize,
  permissions
}) => {
  const [pendingDates, setPendingDates] = useState([]);
  const [idsPartesTrabajoDiario, setIdsPartesTrabajoDiario] = useState([]);
  const [summaryPending, setSummaryPending] = useState([]);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const { filter, formikFilters } = useFilterContext();

  const goToPage = (number) => {
    setPageIndex(number);
  };

  const nextPage = () => {
    if (pageIndex + 1 !== totalPages && totalPages !== 0) {
      setPageIndex(pageIndex + 1);
    }
  };

  const previousPage = () => {
    if (pageIndex !== 0) {
      setPageIndex(pageIndex - 1);
    }
  };

  const onChangeDate = (value) => {
    const selectedDay = formatFullDate(selectedDate, formatsEnum.FORMAT_DATE_2);
    const newDate = formatFullDate(value, formatsEnum.FORMAT_DATE_2);

    if (selectedDay !== newDate) setDateWorkReport(newDate);
  };

  const handleSummaryModal = (value) => {
    setShowSummaryModal(value);
  };

  const postSummaryPending = async () => {
    const { filters } = bulidFilterWorkReportRequestNoPage({
      filters: filter,
      isPending: true
    });

    const response = await postSummaryPendingAdapter(filters);

    setSummaryPending(response);
  };

  useEffect(() => {
    setIsPending(true);
    formikFilters?.setFieldValue('isPending', true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (calendarioRevision) {
      const dates = calendarioRevision.length
        ? calendarioRevision.map((dateCalendar) => {
            const dateCalendarReverse = dateCalendar.split('/').reverse().join('-');

            // Previously the date was formatted with the new Date library, which could set dates incorrectly
            return formatFullDate(dateCalendarReverse, formatsEnum.FORMAT_DATE_2);
          })
        : [];

      setPendingDates(dates);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calendarioRevision]);

  useEffect(() => {
    if (workReports && workReports.length) {
      const arrayIdsPartesDiarios = [];

      workReports.forEach((workReport) => {
        workReport.items.forEach((secondLevelItem) => {
          secondLevelItem.items.forEach((thirdLevelItem) => {
            thirdLevelItem.items.forEach((fourthLevelItem) => {
              fourthLevelItem.items.forEach((fifthLevelItem) => {
                fifthLevelItem.items.forEach((parteTrabajoDiario) =>
                  arrayIdsPartesDiarios.push(parteTrabajoDiario.idParteDiario)
                );
              });
            });
          });
        });
      });
      setIdsPartesTrabajoDiario(arrayIdsPartesDiarios);
    }
    postSummaryPending();
  }, [workReports]);

  return (
    <div className="container-approval-pending">
      <div className="d-flex justify-content-between">
        <div>
          <Label icon="" label="Parte del día" size="md" sizeValue="md" value="" />
          <InputCalendar
            arrayDate={pendingDates}
            handleChangeDate={onChangeDate}
            onClickFirstDay={() => handleGoFirstLastDay(true)}
            onClickLastDay={() => handleGoFirstLastDay()}
            pendingLineTooltipText
            selectDay={selectedDate}
          />
        </div>
        <DailyTotal
          daily={partesDiarios}
          isPending
          onClickSummaryButton={handleSummaryModal}
          title="Pendientes"
          total={partesTotales}
        />
      </div>
      <hr />
      <ApprovalHeaderButtons
        handleOrderByUbication={handleOrderByUbication}
        isEmpty={!workReports?.length}
        isOrderByUbication={isOrderByUbication}
        isPending
        pageNumber={pageIndex}
        pageSize={size}
        selectedDate={selectedDate}
      />
      {workReports?.length ? (
        <>
          {workReports?.map((workReport) => (
            <div className="daily-work-report-container" key={workReport?.agrupadoPor}>
              <HeaderLocation
                isOrderByUbication={isOrderByUbication}
                location={workReport?.agrupadoPor}
              />
              <HeaderTableApprovalPending
                fetchData={fetchData}
                pageIndex={pageIndex}
                permissions={permissions}
                selectedDate={selectedDate}
                selectedInput="PENDIENTES"
                showEditButton={false}
                showPPButton
                size={size}
                // At this level we can find the grouping by either location or provider
                workReportsSecondLevel={workReport?.items}
              />
            </div>
          ))}
          <div className="d-flex justify-content-between">
            <div className="d-flex gap-2">
              <Pagination
                cantFiles={[10, 20, 30, 50]}
                explicitSize
                gotoPage={goToPage}
                nextPage={nextPage}
                pageIndex={pageIndex}
                previousPage={previousPage}
                rowsType={isOrderByUbication ? 'ubicaciones' : 'proveedores'}
                setPageSize={handlePageSize}
                size={size}
                totalPages={totalPages}
              />
              <div className="d-flex justify-content-center align-items-center">
                <h6 className="mb-0" style={{ color: '#797979' }}>
                  Registros totales: {totalRecords}
                </h6>
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <ApprovalButton
                fetchData={fetchData}
                ids={idsPartesTrabajoDiario}
                selectedDate={selectedDate}
              />
            </div>
          </div>
        </>
      ) : (
        <NoWorkReports
          subtitle="-"
          title="No se encontraron partes diarios para la fecha seleccionada"
        />
      )}
      {showSummaryModal && (
        <ModalSummaryApprovalPending
          handleSummaryModal={handleSummaryModal}
          showSummaryModal={showSummaryModal}
          workReportData={{
            total: summaryPending?.partesTotales,
            data: summaryPending?.resumen
          }}
        />
      )}
    </div>
  );
};

export default ApprovalPending;

ApprovalPending.propTypes = {
  calendarioRevision: PropTypes.arrayOf(PropTypes.string).isRequired,
  fetchData: PropTypes.func.isRequired,
  handleGoFirstLastDay: PropTypes.func.isRequired,
  handleOrderByUbication: PropTypes.func.isRequired,
  isOrderByUbication: PropTypes.bool.isRequired,
  pageIndex: PropTypes.number.isRequired,
  partesDiarios: PropTypes.number.isRequired,
  partesTotales: PropTypes.number.isRequired,
  selectedDate: PropTypes.string.isRequired,
  setDateWorkReport: PropTypes.func.isRequired,
  setIsPending: PropTypes.func.isRequired,
  setPageIndex: PropTypes.func.isRequired,
  size: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  totalRecords: PropTypes.number.isRequired,
  workReports: workReportsProp.isRequired,
  handlePageSize: PropTypes.func.isRequired,
  permissions: AttachedFilesPermissions
};

ApprovalPending.defaultProps = {
  permissions: {
    visualize: false,
    write: false
  }
};
